<div class="bg-shrared page-subtitle1 text-white text-center" style="padding: 0.5%;" *ngIf="navigationParams?.hcvTBWLText?.length > 0">
    <div *ngIf="showHCVMsg">{{navigationParams.hcvTBWLText}}</div>
    <div class="page-text text-white">SHRA does not provide immediate emergency housing or hotel vouchers. 
        <br/>For emergency housing, call 211 and press 8 for Homelessness Information and services near you. Having problems connecting to 211? <i class="bi bi-question-circle-fill imgbutton lnk-text-light-blue" (click)="popupClick('211')"></i><br/>
        You can also submit a Mental Health Service Request form <a href="https://mentalhealthservicerequest.saccounty.gov/" target="blank">here</a>.
    </div>
</div>
<app-announcement></app-announcement>
